import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "text-center font-bold"
};
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import Progress from "@/modules/vue/components/Progress.vue";
import { generateColorMap } from "@/modules/vue/utils";
import { ColorEnum } from "@/modules/vue/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeGroup',
  props: {
    title: null,
    attributes: null,
    color: {
      default: ColorEnum.Slate
    }
  },
  setup(__props) {
    const props = __props;
    const colorMap = generateColorMap({
      bg: 50,
      text: 600,
      darkBg: 600,
      darkText: 50
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["p-2 rounded-xl", _unref(colorMap)[__props.color]])
      }, [__props.title ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {}, () => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.attributes, (item, i) => {
        return _renderSlot(_ctx.$slots, "item", _normalizeProps(_mergeProps({
          key: i
        }, item)), () => [_createVNode(FormGroup, {
          label: item.label,
          narrow: ""
        }, {
          default: _withCtx(() => [_createVNode(Progress, {
            value: item.percentage,
            "show-value": ""
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["label"])]);
      }), 128))]), _renderSlot(_ctx.$slots, "after")], 2);
    };
  }
});